import { appcues_event } from "../assets/constants/staticContentConstants";

type appCuesType={
    userId:string,
    user_name:string,
    event_timestamp:Date
}
export const putAppCuesData = (data: any) => {
    const { userId, event_Name } = data;
    const eventHandlers = {
        [appcues_event.login]: createLoginData,
        [appcues_event.programJoined]: createProgramData,
        [appcues_event.communityCommentPosted]: createcommunityCommentPostedData,
        [appcues_event.weekComplete]: createWeekCompleteData,
        [appcues_event.lessonCompleted]: createLessonCompletedData,
        [appcues_event.onlineEventJoined]: createOnlineEventJoinedData,
        [appcues_event.userMentionedInComment]: createuserMentionedInCommentData,
        [appcues_event.lessonStarted]: createlessonStartedData,
        [appcues_event.lessonNoteAdded]: createlessonNoteAddedData,
        [appcues_event.profileCompleted]: createprofileCompletedData,
        [appcues_event.exerciseComplete]: createLessonCompletedData,
    };
    
    const handler = eventHandlers[event_Name?event_Name:data?.eventName];
    
    const userData = handler ? handler(data) : undefined;
    const isAppcuesAvailable = () => {
        if (!window.Appcues) {
          console.warn("Appcues is not available.");
          return false;
        }
        return true;
      };

      const isMixpanelAvailable = () => {
        if (!window.Appcues) {
          console.warn("Mixpanel is not available.");
          return false;
        }
        return true;
      };
    
    if (userData) {
        if(isAppcuesAvailable() ){
            window.Appcues.identify(userId, userData);
            window.Appcues.track(data?.eventName, {});
        }

        if(isMixpanelAvailable()){
            window.mixpanel.identify(userId);
            window.mixpanel.track(data?.eventName, { userData });
        }
    }
};

function createLoginData(data: any) {
    return {
        time_since_last_login: data?.time_since_last_login,
        email:data?.email,
        event_timestamp: new Date().toISOString(),

    };
}

function createProgramData(data: any) {
    return {
        program_id: data?.program_id,
        program_name: data?.program_name,
        event_timestamp: new Date().toISOString(),
    };
}

function createcommunityCommentPostedData(data: any) {
    return {
        lesson_id: data?.lesson_id,
        character_count: data?.character_count,
        event_timestamp: new Date().toISOString(),
    };
}

function createLessonCompletedData(data: any) {
    return {
         lesson_id: data?.lesson_id,
         lesson_name: data?.lesson_name,
         program_id:data?.program_id,
         lesson_type:data?.lesson_type,
         event_timestamp: new Date().toISOString(),
         lesson_duration:data?.lesson_duration,
    };
}

function createOnlineEventJoinedData(data: any) {
    return {
        event_id: data?.event_id,
        event_name:data?.event_name,
        program_id:data?.program_id,
        event_timestamp: new Date().toISOString(),
    };
}

function createuserMentionedInCommentData(data: any) {
    return {
        lesson_id: data?.lesson_id,
        mentioner_user_id: data?.mentioner_user_id,
        event_timestamp: new Date().toISOString(),
    };
}

function createlessonStartedData(data: any) {
    return {
         program_id: data?.program_id,
         lesson_id: data?.lesson_id,
         lesson_name: data?.lesson_name,
         lesson_type: data?.lesson_type,
         event_timestamp: new Date().toISOString(),
    };
}

function createWeekCompleteData(data: any) {
    return {
        program_id: data?.program_id,
        program_name: data?.program_name,
        week_number: data?.week_number,
        event_timestamp: new Date().toISOString()
    };
}

function createlessonNoteAddedData(data: any) {
    return {
        lesson_id: data?.lesson_id,
        event_timestamp: new Date().toISOString(),
        userId:data?.userId,
        lessonName:data?.lessonName
    };
}

function createprofileCompletedData(data: any) {
    return {
        name: data?.name,
        profile_completion_percent: data?.profile_completion_percent,
        event_timestamp: new Date().toISOString()
    };
}

export const appCuesIdentify=(data:appCuesType)=>{
    const {userId}=data
    if(window.Appcues){
        window.Appcues.identify(userId, data);
    }
}


